import { HttpInterceptors } from "./http.interceptor";

export class ChartsService extends HttpInterceptors {
	async mediaChart (filters) {
		const response = await this.axios.get("charts/mediaChart", { params: { filters }});
		return response.data;
	}

	async listRecordsMediaChart (filters) {
		const response = await this.axios.get("charts/listRecordsMediaChart", { params: { filters }});
		return response.data;
	}
}
